import * as env from '../env'

const apiPathPrefix = 'api/v1'

export const apiBasePath = `${env.prtrServer}/${apiPathPrefix}`
